export default "__VITE_ASSET__CFm_LviS__"